import React, { useState } from "react";
import { Tooltip } from "@material-ui/core";
import { FileCopy as CopyIcon } from "@material-ui/icons";
import { QRCodeCanvas } from "qrcode.react";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixQrCodeSectionProps } from "../types";

const PixQrCodeSection: React.FC<PixQrCodeSectionProps> = ({
  qrCodeValue,
  pixCopiaECola,
}) => {
  const classes = usePixModalStyles();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pixCopiaECola);
      setCopied(true);
      setTimeout(() => setCopied(false), 1300);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = pixCopiaECola;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 1300);
    }
  };

  return (
    <div className={classes.qrBox}>
      <div className={classes.qrCanvas}>
        <QRCodeCanvas value={qrCodeValue} size={160} includeMargin />
      </div>
      <div className={classes.qrCodeText} title={pixCopiaECola}>
        {pixCopiaECola}
      </div>
      <Tooltip title={copied ? "Copiado!" : "Copiar código Pix"}>
        <button
          className={classes.btnCopy}
          onClick={handleCopy}
          aria-label="Copiar código Pix"
        >
          <CopyIcon style={{ fontSize: 14 }} />
          {copied ? "Copiado!" : "Copiar código Pix"}
        </button>
      </Tooltip>
    </div>
  );
};

export default PixQrCodeSection;
